/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UserParticipationSummaryDto
 */
export interface UserParticipationSummaryDto {
    /**
     * Participation ID
     * @type {string}
     * @memberof UserParticipationSummaryDto
     */
    'id': string;
    /**
     * Challenge name
     * @type {string}
     * @memberof UserParticipationSummaryDto
     */
    'challengeName': string;
    /**
     * Challenge category (distance)
     * @type {string}
     * @memberof UserParticipationSummaryDto
     */
    'category': string;
    /**
     * Participation status
     * @type {string}
     * @memberof UserParticipationSummaryDto
     */
    'status': UserParticipationSummaryDtoStatusEnum;
    /**
     * URL of the electronic bib number image
     * @type {string}
     * @memberof UserParticipationSummaryDto
     */
    'eBibUrl'?: string;
    /**
     * URL of the electronic certificate image
     * @type {string}
     * @memberof UserParticipationSummaryDto
     */
    'eCertUrl'?: string;
}

export const UserParticipationSummaryDtoStatusEnum = {
    Ongoing: 'ongoing',
    Completed: 'completed',
    Cancelled: 'cancelled'
} as const;

export type UserParticipationSummaryDtoStatusEnum = typeof UserParticipationSummaryDtoStatusEnum[keyof typeof UserParticipationSummaryDtoStatusEnum];


